import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import type { FC, ReactNode } from "react";
import Skeleton from "react-loading-skeleton";

import { useMessagesContext } from "src/messages";
import type { BannerPageEnum } from "src/types";
import { cn } from "src/utils";
import { Banner } from "../Banner";
import { Heading } from "../Heading";
import { Loading } from "../Loading";
import { Message } from "../Message";
import { NavigationMenuDesktop, TopBar } from "./Navigation";

type PageLayoutProps = Readonly<{
    children: ReactNode;
    title?: string;
    className?: string;
    titleClassName?: string;
    loading?: boolean;
    titleLoading?: boolean;
    rightCornerComponent?: ReactNode;
    banner?: BannerPageEnum;
}>;

export const PageLayout: FC<PageLayoutProps> = ({
    children,
    title,
    loading,
    rightCornerComponent,
    banner,
    className,
    titleClassName,
    titleLoading,
}) => {
    const { isMessageVisible, message, countDownTill } = useMessagesContext();
    return (
        <>
            <NavigationMenuDesktop className="hidden xl:flex" />
            <main className={cn("relative flex max-w-full flex-col xl:ml-left-menu-width", className)}>
                {isMessageVisible && message && <Message countDownTill={countDownTill} text={<BlocksRenderer content={message.text} />} />}
                <TopBar className="sticky top-0 z-30 bg-white xl:hidden" />
                <div className="flex flex-1 flex-col gap-10 px-16 py-9 max-sm:gap-8 max-sm:p-4">
                    <div className={cn("flex flex-col items-start gap-4 sm:flex-row sm:justify-between", titleClassName)}>
                        {titleLoading ? (
                            <Skeleton width={200} height={40} />
                        ) : (
                            <Heading level={1} className={"inline-block font-manrope text-3xl font-bold sm:text-4xl"}>
                                {title}
                            </Heading>
                        )}
                        {rightCornerComponent && <div>{rightCornerComponent}</div>}
                    </div>
                    {banner && <Banner page={banner} />}
                    {loading ? <Loading /> : children}
                </div>
            </main>
        </>
    );
};
